import { useTranslation } from 'i18n';
import { Typography } from 'ui';

export const GuideTitle = ({ obfuscateAi }: { obfuscateAi: boolean }) => {
  const { t } = useTranslation('features');

  return (
    <Typography variant="body2" color="secondary">
      {obfuscateAi ? t('helpGuides.guideTitle.obfuscatedAi') : t('helpGuides.guideTitle.withAi')}
    </Typography>
  );
};
